import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { TONE_SURFACES } from '@/lib/tones'
import SectionLabel from '@/components/landing/section-label'
import { PROCESS_STEPS } from '@/constants/landing'

// Alternating tilt and offset so the cards read like stickers on a wall.
const CARD_SHIFTS = ['xl:-rotate-2', 'xl:mt-10 xl:rotate-1', 'xl:-rotate-1', 'xl:mt-10 xl:rotate-2']

const ProcessSection: FC = (): ReactNode => {
    return (
        <section id='process' aria-labelledby='process-title' className='site-container py-24 md:py-36'>
            <div className='grid gap-8 lg:grid-cols-12 lg:items-end'>
                <div className='lg:col-span-9'>
                    <SectionLabel index='04'>
                        Process
                    </SectionLabel>

                    <h2
                        id='process-title'
                        className='reveal mt-6 font-heading text-[clamp(3.25rem,9vw,9rem)] leading-[0.82] font-black uppercase wdth-75'
                    >
                        Brief to shelf
                        <span className='block text-pop-orange'>
                            in 12 weeks
                        </span>
                    </h2>
                </div>

                <p className='reveal text-lg leading-relaxed text-muted-foreground lg:col-span-3'>
                    One senior team from first call to finished artwork, with a fixed price and zero surprise invoices.
                </p>
            </div>

            <ol className='mt-14 grid gap-4 md:mt-20 md:grid-cols-2 xl:grid-cols-4 xl:gap-5'>
                {PROCESS_STEPS.map((step, index) => (
                    <li
                        key={step.title}
                        className={cn(
                            'reveal flex min-h-[20rem] flex-col rounded-[2rem] p-6 md:min-h-[24rem] md:p-7 xl:self-start',
                            TONE_SURFACES[step.tone],
                            CARD_SHIFTS[index % CARD_SHIFTS.length]
                        )}
                    >
                        <span aria-hidden='true' className='font-heading text-[clamp(5rem,9vw,8rem)] leading-[0.8] font-black wdth-62'>
                            {step.number}
                        </span>

                        <div className='mt-auto pt-10'>
                            <span className='inline-block rounded-full border-[1.5px] border-current px-3 py-1 font-mono text-[0.7rem] font-medium tracking-[0.14em] whitespace-nowrap uppercase'>
                                {step.timing}
                            </span>

                            <h3 className='mt-4 font-heading text-4xl leading-none font-black uppercase wdth-80 2xl:text-5xl'>
                                <span className='sr-only'>
                                    Step {step.number}:{' '}
                                </span>
                                {step.title}
                            </h3>

                            <p className='mt-3 text-base leading-relaxed'>
                                {step.description}
                            </p>
                        </div>
                    </li>
                ))}
            </ol>
        </section>
    )
}

export default ProcessSection
